import { LINK_EXISTING_MOBILE_NUMBER_WITH_SALESMSG } from 'shared/constants/links'
import type { IResponseGetNumbersLookup } from 'entities/Phone/api/types'

export const errorNumberLookup = (response: IResponseGetNumbersLookup) => {
  if (response.type === 'landline') return ''

  const helpLink = `<a target="_blank" href=${LINK_EXISTING_MOBILE_NUMBER_WITH_SALESMSG}>Learn more</a>`
  switch (response.type) {
    case 'mobile':
      return 'Sorry, we’re unable to host this ' + response.carrier + ' mobile number. ' + helpLink
    case 'fixedVoip':
    case 'nonFixedVoip':
      return 'Sorry, we’re unable to host this ' + response.carrier + ' VOIP number. ' + helpLink
    case 'tollFree':
      return 'Sorry, we’re unable to host this toll-free number.'
    default:
      return 'Sorry, we’re unable to host this number. ' + helpLink
  }
}
